import {
    GET_SKETCH_TECH_USER_PROFILES_REQUEST,
    GET_SKETCH_TECH_USER_PROFILES_SUCCESS,
    GET_SKETCH_TECH_USER_PROFILES_FAILURE,
} from "../actions/actionTypes";

const initState = {
    isFetching: false,
    sketchTechUserProfiles: [],
    totalPages: 0,
    currentPage: 0,
};

const sketchTechUserProfilesReducer = (state = initState, action) => {
    switch (action.type) {
        case GET_SKETCH_TECH_USER_PROFILES_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
            });
        case GET_SKETCH_TECH_USER_PROFILES_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                sketchTechUserProfiles: action.response.resourceList,
                totalPages: action.response.totalPages,
                currentPage: action.response.currentPage,
            });
        case GET_SKETCH_TECH_USER_PROFILES_FAILURE:
            return initState;
        default:
            return state;
    }
};

export default sketchTechUserProfilesReducer;
